import MatchFidelityForm from '../CompanysFidelityForms/MatchFidelityForm';
import { COMPANY_IDS } from './companyName';

export const companyFormList = {
  [COMPANY_IDS.MATCH]: MatchFidelityForm,
};

export const getCompanyForm = (companyId) => companyFormList[companyId] || null;
